<template>
  <NPopconfirm v-bind="popConfirmAttrs">
    <NButton v-bind="btnAttrs">
      <slot>
        {{ $tl('remove') }}
      </slot>
    </NButton>
  </NPopconfirm>
</template>

<script setup>
import {computed, useAttrs} from 'vue';
import {useExecute, useLanguage} from '@front/hooks';

const { tl, t, PREFIX } = useLanguage();
const attrs = useAttrs();
const props = defineProps({
  loading: Boolean,
  type: { type: String, default: 'link' },
  onConfirm: Function,
  onClick: Function,
});

const { loading, execute } = useExecute({ execute: props.onConfirm });

const popConfirmAttrs = computed(() => {
  return {
    title: t('title', PREFIX.CONFIRM, { action: tl(`remove`).toLowerCase() }),
    onConfirm: execute,
    onClick: props.onClick,
  };
});

const btnAttrs = computed(() => {
  return {
    type: props.type,
    danger: true,
    ...attrs,
    loading: props.loading || loading.value,
  };
});
</script>

<script>
export default {
  name: 'NRemove',
  inheritAttrs: false,
};
</script>

<style lang="less">
.n-remove {
  display: inline-block;
}
</style>
